var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H1280V860H0z",
    transform: "translate(-621 -124)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#D8D8D8",
    d: "M645 114.5H305c-1.243 0-2.368.504-3.182 1.318-.814.814-1.318 1.94-1.318 3.182v30c0 1.243.504 2.368 1.318 3.182.814.814 1.94 1.318 3.182 1.318h340c1.243 0 2.368-.504 3.182-1.318.814-.814 1.318-1.94 1.318-3.182v-30c0-1.243-.504-2.368-1.318-3.182-.814-.814-1.94-1.318-3.182-1.318z",
    transform: "translate(-621 -124)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#474A68",
    fillRule: "nonzero",
    d: "M635.646 129.37c.174.173.193.442.058.637l-.058.07-4.046 4.045 4.046 4.047c.195.195.195.511 0 .707-.173.173-.443.193-.638.058l-.069-.058-4.046-4.047-4.046 4.047c-.196.195-.512.195-.707 0-.174-.174-.193-.443-.058-.638l.058-.07 4.046-4.046-4.046-4.046c-.196-.195-.196-.512 0-.707.173-.174.442-.193.637-.058l.07.058 4.046 4.046 4.046-4.046c.195-.195.512-.195.707 0z",
    transform: "translate(-621 -124)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup3);
export default __webpack_public_path__ + "static/media/group-3.3caa782b42bba5231e7fd27b2375ca48.svg";
export { ForwardRef as ReactComponent };